<template>
  <div v-if="currentOutcome" class="injects">
    <h2>Learning Outcomes</h2>
    <transition name="fade" mode="out-in">
      <div class="rounded inject-container" :key="current">

        <header>
          <h2 class="inject-title" v-text="currentOutcome.name"></h2>
          <button v-if="currentOutcome.description" @click="openInfo(currentOutcome)"><i class="material-icons">info</i></button>
          <button v-if="currentOutcome.type != 'pdf'" @click="openModal(currentOutcome)"><i class="material-icons">launch</i></button>
        </header>

        <vue-plyr v-if="currentOutcome.type == 'video'" :options="videoOptions" class="rounded">
          <video :poster="currentOutcome.thumb" :src="currentOutcome.src">
            <source :src="currentOutcome.src" type="video/mp4" size="720">
          </video>
        </vue-plyr>

        <figure v-if="currentOutcome.type == 'image' || currentOutcome.type == 'map'" class="rounded">
          <img :src="currentOutcome.image" />
        </figure>

        <div v-if="currentOutcome.type == 'pdf'" class="file-download rounded">
          <a :href="currentOutcome.src" :title="currentOutcome.name" target="_blank" class="download-link">{{currentOutcome.name}} <i class="material-icons">cloud_download</i> </a>
        </div>
      </div>
    </transition>

    <div class="navigation-container">
      <button 
        class="prev-button btn rounded" 
        v-if="current > 0"
        @click="current--">
          <i class="material-icons">arrow_back</i><span>Previous</span>
      </button>
      <button 
        class="next-button btn rounded" 
        v-if="current != injects.length -1"
        @click="current++">
          <span>Next</span><i class="material-icons">arrow_forward</i>
      </button>
    </div>

    <div class="button-container">
      <button @click="$emit('continue')" class="btn large"><span>Continue</span> <i class="material-icons">arrow_forward</i></button>
    </div>
  </div>
</template>

<script>
import { scenarioMixin } from '@/mixins/scenarioMixin.js'
export default {
  name: "LearningOutcomes",
  mixins: [scenarioMixin],
  data () {
    return {
      injects: [],
      current: 0,
      videoOptions: {
        autoplay: false
      }
    }
  },
  mounted () {
    this.getInjects()
  },
  computed: {
    currentOutcome () {
      return this.injects[this.current]
    }
  },
  methods: {
    openModal (inject) {
      this.$store.dispatch('modalModule/setActive', inject )
    },
    openInfo (inject) {
      this.$store.dispatch('modalModule/setActive', {...inject, type: "description"} )
    },
    openMap (map) {
      this.$store.dispatch('modalModule/setActive', {...map, type: "image"} )
    },
    getInjectData (id) {
      return this.$store.getters["scenarioModule/getInject"](id);
    },
    getInjects () {
      this.injects = []
      this.playlistData.outcomes.forEach(inject => {
        let data = this.getInjectData(inject)
        this.injects.push(data)

        if ( data.image) {
          // Preload images
          const image = new Image()
          image.src = data.image
        }
        if ( data.thumb) {
          // Preload images
          const image = new Image()
          image.src = data.thumb
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
h2 {
  color: var(--primary);
  width: 100%;
  margin: 25px 25px 1em;
  // padding: 0 20px;
}
.injects {
  // padding: 25px;
  width: 100%;

  @media all and (max-width: 540px) {
    // padding: 10px;
  }
}
.inject-container {
  background-color: #E2E8FF;
  padding: 10px 3px 3px 3px;
  max-width: 720px;
  width: calc(100% - 50px);
  margin: 25px;
  

  header {
    display: flex;
    align-items: center;
    margin: 0 0 1em 1em;

    button {
      color: var(--primary);

      &:hover {
        color: #e1651d;
      }
    }
  }

  h2 {
    color: var(--primary);
    font-size: 15px;
    font-weight: normal;
    margin-right: auto;
  }

  video {
    max-height: calc(98vh - 60px);
  }

  figure {
    margin: 0;
    
    img {
      max-width: 100%;
      max-height: calc(98vh - 60px);
    }
  }
  .file-download {
    width: 100%;
    background-color: #fff;
    padding: 3px 15px;

    a {
      color: var(--primary);
      text-decoration: none;
      display: flex;
      align-items: center;

      i {
        margin-left: 15px;
      }
      
      &:hover {
        color: #e1651d;
      }
    }
  }
}

.navigation-container {
  display: flex;
  justify-content: space-between;
  padding: 25px;
  
  .prev-button {
    margin-right: auto;
  }

  .next-button {
    margin-left: auto;
  }
}
</style>